import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setTitle } from '../../redux/title/action';

export const Register = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setTitle('ทดสอบ'));
  }, [dispatch]);
  return <div>Register</div>;
};
